import { useEffect, useRef, useState } from "react";
import PageContainer from "@components/layout/PageContainer";
import { useNavigate, useParams } from "react-router-dom";
import { ModelIndexHandle } from "@components/layout/ModelIndex";
import { DebitnoteApi } from "@/api/DebitnoteApi";
import DebitnoteModelIndex from "@components/dynamic/modelIndexes/DebitnoteModelIndex";
import { InvoiceApi, InvoiceDataType } from "@/api/InvoiceApi";

const DebitnoteListByInvoiceId = () => {
  const navigate = useNavigate();
  const params = useParams()
  const { invoiceId } = params;
  const modelRef = useRef<ModelIndexHandle>(null);
  const [invoiceData, setInvoiceData] = useState<InvoiceDataType>({});

  useEffect(() => {
    loadInvoice()
  }, [invoiceId]);

  const loadInvoice = async () => {
    if (invoiceId) {
      const invoice = await InvoiceApi.get(invoiceId);
      setInvoiceData(invoice)
    } else {
      alert("No fue posible cargar la informacion de la factura")
    }
  }

  return (
    <PageContainer
      title={`Lista de Notas de Debito de Factura #${invoiceData.numero || ""}`}
      backUrl="/user/dashboard-accounting"
      primaryActions={[
        {
          onClick: () => {
            navigate('/user/debitnotes/invoice-select')
          },
          actionTitle: "Nueva",
          color: "success"
        }
      ]}
    >
      <DebitnoteModelIndex
        ref={modelRef}
        messages={{
          noResults: `No hay notas de debito para la Factura #${invoiceData.numero}`
        }}
        mandatoryFilters={[{ invoiceId: { eq: invoiceId } }]}
        fetchData={(...args) => DebitnoteApi.fetchAll(...args)}
      >
      </DebitnoteModelIndex>
    </PageContainer >
  );
}

export default DebitnoteListByInvoiceId;
